// ======================================================================
// FILE:
// src/modules/service_crm/visits/services/serviceVisitService.js
//
// MODULE:
// Service CRM
//
// FEATURE:
// Service Visit Queue
// ======================================================================

import axiosClient from "../../../../api/axiosClient";


// ======================================================================
// VISIT QUEUE
// ======================================================================

const getVisitQueue = async (
  params = {}
) => {

  const res =
    await axiosClient.get(

      "/api/service-crm/visits",

      {
        params,
      }

    );

  return (
    res.data.data
  );

};


// ======================================================================
// EXPORT
// ======================================================================

const serviceVisitService = {

  getVisitQueue,

};

export default serviceVisitService;